import { useEffect, type Dispatch, type SetStateAction } from "react";

/**
 * Atalho global ⌘K / Ctrl+K — abre a pesquisa do sistema. A SideBar só é montada nas páginas
 * gerais (dentro de uma obra o ProjectQuickSwitcher cuida do ⌘K), então não há conflito de duplo atalho.
 */
export function useSearchShortcut(setOpen: Dispatch<SetStateAction<boolean>>): void {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setOpen((open) => !open);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [setOpen]);
}
